import { observe, observable, Lambda, action } from "mobx";
import { SelectionModel, PurchaseModel, ErrorModel, BetModel, StakeButtonsStatusesModel } from "../models";
import { Retriever } from "../retriever";
import { BetStatus } from "../enums";

export class Parser {
    private retriever: Retriever;
    private disposeBets: Lambda;
    private disposeErrors: Lambda;
    private disposePurchases: Lambda;
    private disposeSelections: Lambda;
    private disposeStatus: Lambda;
    private disposeStakeButtonsStatus: Lambda;
    private disposePlaceBetButtonState: Lambda;

    @observable bets: BetModel[];
    @observable errors: ErrorModel[];
    @observable purchases: PurchaseModel[];
    @observable selections: SelectionModel[];

    @observable isPlaceBetButtonEnabled: boolean;
    @observable betStatus: number;
    @observable stakeButtonsStatus: StakeButtonsStatusesModel | any; //added any as an option of updatedStatus type because jest doesn't covere it

    constructor(retriever: Retriever) {
        this.retriever = retriever;
        this.bets = [];
        this.errors = [];
        this.purchases = [];
        this.selections = [];
        this.isPlaceBetButtonEnabled = false;
        this.disposeBets = () => { };
        this.disposeErrors = () => { };
        this.disposePurchases = () => { };
        this.disposeSelections = () => { };
        this.disposeStatus = () => { };
        this.disposeStakeButtonsStatus = () => { };
        this.disposePlaceBetButtonState = () => { };
        this.betStatus = BetStatus.Default;
        this.stakeButtonsStatus = this.retriever.stakeButtonsStatus;
    }

    activate() {
        this.disposeBets = observe(this.retriever, "bets", x => {
            this.parseToBets(x.newValue);
        });

        this.disposeErrors = observe(this.retriever, "errors", x => {
            this.parseToErrorModels(x.newValue);
        });

        this.disposePurchases = observe(this.retriever, "purchases", x => {
            this.parseToPurchaseModels(x.newValue);
        });

        this.disposeSelections = observe(this.retriever, "liveSelections", x => {
            this.parseToSelectionModels(x.newValue);
        });

        this.disposeSelections = observe(this.retriever, "preliveSelections", x => {
            this.parseToSelectionModels(x.newValue);
        });

        this.disposeStatus = observe(this.retriever, "betStatus", x => {
            this.parseStatus(x.newValue);
        });

        this.disposeStakeButtonsStatus = observe(this.retriever, "stakeButtonsStatus", x => {
            this.parseStakeButtonsStatus(x.newValue);
        });

        this.disposePlaceBetButtonState = observe(this.retriever, "isPlaceBetButtonEnabled", x => {
            this.setIsBetButtonEnabled(x.newValue);
        })

        this.retriever.activate();
    }

    @action.bound deactivate() {
        this.retriever.deactivate();
        this.disposeBets();
        this.disposeStatus();
        this.disposeErrors();
        this.disposePurchases();
        this.disposeSelections();
        this.disposeStakeButtonsStatus();
        this.disposePlaceBetButtonState();
        this.stakeButtonsStatus = Object.create({});
    }

    @action.bound parseToErrorModels(updatedErrors: ErrorModel[]) {
        this.errors = updatedErrors;
        return this.errors;
    }

    @action.bound parseToPurchaseModels(updatedPurchases: PurchaseModel[]) {
        this.purchases = updatedPurchases;
        return this.purchases;
    }

    @action.bound parseToSelectionModels(updatedSelections: SelectionModel[]) {
        this.selections = updatedSelections;
        return this.selections;
    }

    @action.bound parseToBets(bets: BetModel[]) {
        this.bets = bets;
        return this.bets;
    }

    @action.bound parseStatus(updatedStatus: number) {
        this.betStatus = updatedStatus;
        return this.betStatus;
    }

    //added any as an option of updatedStatus type because jest doesn't covere it
    @action.bound parseStakeButtonsStatus(updatedStatus: StakeButtonsStatusesModel | any) {
        this.stakeButtonsStatus = updatedStatus;
        return this.stakeButtonsStatus;
    }

    @action.bound setIsBetButtonEnabled(value: boolean) {
        this.isPlaceBetButtonEnabled = value;
        return this.isPlaceBetButtonEnabled;
    }

    placeBet(stake: string, selections: SelectionModel[]) {
        return this.retriever.placeBet(stake, selections);
    }

    removeSelections(selections: SelectionModel[]) {
        return this.retriever.removeSelectionsRequest(selections);
    }

    @action.bound retainPurchase(purchaseId: string, purchaseViewKey: number) {
        return this.retriever.retainPurchaseRequest(purchaseId, purchaseViewKey);
    }

    @action.bound clearPurchase(purchaseId: string, purchaseViewKey: number) {
        return this.retriever.clearPurchaseRequest(purchaseId, purchaseViewKey);
    }

    @action.bound clearAllPurchases(purchases: PurchaseModel[]) {
        return this.retriever.clearAllPurchases(purchases);
    }
    updateNewOfferStatus(waitingBetId: string, isAccepted: boolean){
        this.retriever.updateNewOfferStatus(waitingBetId, isAccepted);
    }

    updateOddsChangeStatus(isAccepted: boolean) {
        this.retriever.updateOddsChangeStatus(isAccepted);
    }

    changeStake(stake: string, buttonAction?: string) {
        return this.retriever.changeStake(stake, buttonAction);
    }
}